export enum OENLockingProfileType {
  PERSISTENT,
  TEMPORARY,
}
